// Middleware to control visibility actions based on "Apply To" settings
import { SET_VISIBLE_PRODUCTS } from 'actions/productVisibilityActions';
import { getApplyToSelector } from './Helpers';

// This middleware intercepts SET_VISIBLE_PRODUCTS actions and 
// conditionally lets them through based on the Apply To Selector state
const filterMiddleware = () => next => action => {
  // Only intercept SET_VISIBLE_PRODUCTS actions
  if (action.type === SET_VISIBLE_PRODUCTS) {
    // Only allow this action to proceed if Apply To Selector is checked
    if (getApplyToSelector()) {
      return next(action);
    } 
    // Otherwise, block it (do nothing)
    return;
  }
  
  // For all other actions, proceed normally
  return next(action);
};

export default filterMiddleware;